<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-4">HR Admin<span><a v-bind:href="$api_url + '/core-hr'">HR
                    Admin</a> / Company Signatories</span></h4>

        <div class="reports-tab-nav"> <!-- Mustafijur Added: <div class="reports-tab-nav"> on 09-04-2026 -->
            <div class="clearfix row py-2 mb-2">
                <div class="col-sm-6 px-3 company-form-box-title">Company Signatories</div>
                <div class="col-sm-5 float-right  ml-5 custom-search d-none">
                    <b-input-group class="mb-0">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search"
                            @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
                <div class=" col-sm-6 float-right text-right pr-0">
                    <b-button id="show-btn" class="mr-3" v-if="ce" @click="addNew()">+ Add Signatory</b-button>
                    <!-- Mustafijur Added: + and removed b-icon on 09-04-2026 -->
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-sm-12  px-0" v-if="this.ce">
                    <!-- alpha fix- make the title dynamic  -->
                    <b-modal id="bv-modal-signatory" size="lg" hide-footer :title=Signatory_modal>
                        <b-overlay :show="showoverlay" rounded="sm">

                            <b-form @submit.stop.prevent="onSubmit" class="" :key="fkey">
                                <input type="hidden" v-model="fdata.id" name="id">
                                <div class="clearfix">

                                    <div class="custom-control mr-3">
                                        <input type="radio" id="signatory_manual" class="custom-control-input"
                                            name="signatory_type" value="1" v-model="signatory_type" />
                                        <label class="custom-control-label" for="__BVID__239">Manual input</label>
                                    </div>
                                    <div class="custom-control">
                                        <input type="radio" id="signatory_employee" class="custom-control-input"
                                            name="signatory_type" value="0" v-model="signatory_type" />
                                        <label class="custom-control-label" for="__BVID__239">Employee selection
                                        </label>
                                    </div>
                                    <template v-if="signatory_type == 0">

                                        <!-- <b-form-group id="employee_selection-group" label="" label-for="manager_id">
                                            <input class="form-control" type="text" id="employee_selection"
                                                autocomplete="off" v-model="employeeSearch.name"
                                                placeholder="Select Employee" @click.prevent="employeesetSearch()">
                                            <div class="dropdown_div" id="dropdown_div">
                                                <table class="list1" id="manager_dropdown">
                                                    <tr v-for="m in filteredItems" :key="m.employee_id"
                                                        style="border-bottom: 1px solid #CCC;">
                                                        <td>
                                                            <a
                                                                @click="chooseeEmployee(m.text, m.jobposition)">{{ m.text }}</a>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </b-form-group> -->


                                        <b-form-group id="employee_selection-group" class="signatory-employee-search"
                                            label="" label-for="manager_id">
                                            <input class="form-control" type="text" id="employee_selection"
                                                autocomplete="off" v-model="employeeSearch.name"
                                                placeholder="Select Employee" @click.prevent="employeesetSearch()">
                                            <div class="dropdown_div" id="dropdown_div">
                                                <table class="list1" id="manager_dropdown">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="m in filteredItems" :key="m.employee_id">
                                                            <td>
                                                                <a @click="chooseeEmployee(m.text, m.jobposition)">{{
                                                                    m.text }}</a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </b-form-group>


                                    </template>

                                    <b-form-group id="name-group" label="Name" class="required-field" label-for="name">
                                        <b-form-input id="name" name="name" v-model="fdata.name"
                                            v-validate="{ required: true, min: 3 }" :state="validateState('name')"
                                            aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                                        <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name')
                                        }}</b-form-invalid-feedback>
                                    </b-form-group>
                                    <b-form-group id="designation-group" label="Designation" class="required-field"
                                        label-for="designation">
                                        <b-form-input id="designation" name="designation" v-model="fdata.designation"
                                            v-validate="{ required: true, min: 3 }"
                                            :state="validateState('designation')"
                                            aria-describedby="designation-feedback"
                                            data-vv-as="Designation"></b-form-input>
                                        <b-form-invalid-feedback id="designation-feedback">{{
                                            veeErrors.first('designation') }}</b-form-invalid-feedback>
                                    </b-form-group>








                                    <div id="signature-group" role="group" class="form-group">

                                        <div class="custom-control">
                                            <input type="radio" id="signatory_manual" class="custom-control-input"
                                                name="signatory_upload_type" value="1"
                                                v-model="signatory_upload_type" />
                                            <label class="custom-control-label" for="__BVID__239">Upload Signature
                                            </label>
                                        </div>

                                        <div class="custom-control">
                                            <input type="radio" id="signatory_employee" class="custom-control-input"
                                                name="signatory_upload_type" value="0"
                                                v-model="signatory_upload_type" />
                                            <label class="custom-control-label" for="__BVID__239">Use Signature
                                                Pad</label>
                                        </div>

                                        <div class="custom-control">
                                            <input type="radio" id="no_signatory" class="custom-control-input"
                                                name="signatory_upload_type" value="2"
                                                v-model="signatory_upload_type" />
                                            <label class="custom-control-label" for="__BVID__239">No Signature</label>
                                        </div>
                                        <div v-if="signatory_upload_type != 2">
                                            <div v-if="signatory_upload_type == 1">
                                                <label id="signature-group__BV_label_" for="signature"
                                                    class="d-block my-2">[click to upload]</label>

                                                <div class="bv-no-focus-ring cmpny-logo-uploader"
                                                    style="width:300px; border:1px solid #464d5c; display:block;">
                                                    <my-upload field="img" @crop-success="cropSuccess"
                                                        v-model="showLogoUploader" lang-type="en" :width="400"
                                                        :height="200" img-format="jpeg"></my-upload>

                                                    <img :src="logoUrl" @click="toggleLogoUploader"
                                                        style="cursor: pointer;">
                                                    <div @click="toggleLogoUploader" class="cmpny-logo-overlay">Upload
                                                    </div>
                                                </div>
                                                Expected size at least: 400*200
                                            </div>

                                            <div v-else>
                                                <label id="signature-group__BV_label_" for="signature"
                                                    class="d-block my-2">[sign below]</label>
                                                <div class="border" style="width: 400px;height: 150px;">
                                                    <VueSignaturePad width="400px" height="150px" ref="signaturePad"
                                                        :options="{ onBegin: () => { $refs.signaturePad.resizeCanvas() } }"
                                                        style="background: #eee;" />
                                                </div>
                                                <div>
                                                    <a class="btn btn-dark my-2" @click="undoSignaturePad">Undo</a>


                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="text-center">
                                        <!-- Mustafijur Changed: text-right to text-center on 09-04-2026 -->

                                        <b-button v-if="fdata.id > 0" type="submit" variant="primary" style=""><b-icon
                                                variant="light" icon="pencil" scale="1" width="20px" height="20px"
                                                class="align-left mr-2"></b-icon>Save Signatory</b-button>
                                        <b-button v-else type="submit" variant="primary" style=""><b-icon
                                                variant="light" icon="plus-circle" scale="1" width="20px" height="20px"
                                                class="align-left mr-2"></b-icon>Add Signatory</b-button>

                                    </div>
                                </div>
                            </b-form>
                        </b-overlay>
                    </b-modal>
                </div>


                <div class="col-sm-12"> <!-- Mustafijur Removed: class px-0 on 09-04-2026 -->
                    <b-overlay :show="showoverlay_list" rounded="sm">
                        <!-- alpha fix added class border  -->
                        <table class="table list-tables border">
                            <thead class="" style="">
                                <tr class="table-head">
                                    <!-- alpha fix- removed class pl-5 -->
                                    <td class="">#</td>
                                    <td>Name</td>
                                    <td>Designation</td>
                                    <td>Signature</td>
                                    <td class="text-right" v-if="ce">Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-row hover-bg" v-for="(signatory, n) in paginatedData"
                                    :key="signatory.id">

                                    <!-- alpha fix- added text-center -->
                                    <td class="text-center">{{ signatory.index }}</td>
                                    <td class=" ">{{ signatory.name }}</td>
                                    <td class="">{{ signatory.designation }}</td>
                                    <template v-if="signatory.signature">
                                        <td class=""><img
                                                v-bind:src="$api_url + '/images/company/signature/' + signatory.signature"
                                                width="200" height="100"> </td>
                                    </template>
                                    <template v-else>
                                        <td class=""> </td>
                                    </template>


                                    <td class="position-relative text-right" v-if="ce">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <!-- Abdullah26 added px-1  -->
                                        <div class="dropdown-menu action-dropdown-menu w-200 px-1"
                                            aria-labelledby="actionDropdown">

                                            <b-button-group class="mr-0">
                                                <!-- Abdullah26 added px-1  -->
                                                <b-button class="mr-3 rounded edit-btn text-left" title="Edit Signatory"
                                                    @click="editSignatory(signatory.id)">
                                                    <b-icon icon="pencil" class="mr-2" aria-hidden="true"></b-icon>Edit
                                                </b-button>
                                                <!-- Abdullah26 added px-1  -->
                                                <b-button class="rounded delete-btn text-left" title="Delete Signatory"
                                                    @click="deleteSignatory(signatory.id)">
                                                    <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                </b-button>
                                            </b-button-group>

                                        </div>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- alpha fix commented this  -->
                        <!-- <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="px-3"><b-pagination-nav v-model="pagination.currentPage"
                                :number-of-pages="pagination.pages" base-url="#" first-number last-number><template
                                    #prev-text><span>&laquo;</span></template><template
                                    #next-text><span>&raquo;</span></template></b-pagination-nav></div> -->


                        <!-- alpha fix- added this  -->
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="row py-2 no-margin">
                            <div class="col-md-12 p-0 no-margin">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length"
                                            :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
                                </ul>
                                <b-pagination-nav v-model="pagination.currentPage" :number-of-pages="pagination.pages"
                                    base-url="#" first-number last-number><template
                                        #prev-text><span>Previous</span></template><template
                                        #next-text><span>Next</span></template></b-pagination-nav>
                            </div>
                        </div>
                    </b-overlay>

                </div>
            </div>
        </div> <!-- Mustafijur Added: </div> on 09-04-2026 -->
    </div>
</template>
<style scoped>
.custom-control-input {
    z-index: 11;
}
/* alpha fix- added this  */
.list-tables {
    border-collapse: collapse !important;

}
</style>


<script>
import Vue from 'vue';
import myUpload from 'vue-image-crop-upload';
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);
export default {
    name: 'MySignaturePad',
    mounted() {
        if (this.check_ce == 1) {
            if (this.ce_flg == 1)
                this.ce = true;
            else
                this.ce = false;


        }
    },
    props: ['ce_flg', 'check_ce'],
    components: { 'my-upload': myUpload },
    data() {

        return {

            signatories: [],
            manager: [],
            employeeSearch:
            {
                name: "",
            },

            showoverlay: false,
            showoverlay_list: false,
            movenext: false,

            errormsg: [],
            fdata: { id: null, name: '', designation: '' },
            signatory_type: 1,
            signatory_upload_type: 1,

            search: '',
            length: 20,
            pagination: { currentPage: 1, pages: 1 },

            ce: true,

            logoUrl: '',
            logoUploaded: false,
            showLogoUploader: false,
            fkey: 0,

            // alpha fix- added this
            temp_length: 20,
            people: 0,
            length_options: [
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
            ],
            Signatory_modal: "Add Signatory",
        }
    },
    methods: {

        undoSignaturePad() {
            this.$refs.signaturePad.clearSignature();
        },

        saveSignaturePad() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            console.log(isEmpty);
            console.log(data);
        },


        toggleLogoUploader() {
            this.showLogoUploader = !this.showLogoUploader;
        },
        cropSuccess(imgDataUrl, field) {

            this.logoUrl = imgDataUrl;
            this.logoUploaded = true;
        },


        getManagers: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/manager/details', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.manager = response.data;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

        employeesetSearch: function (pageflg) {
            document.getElementById('dropdown_div').style.zIndex = "1";
            this.eligible_pf = 0;
            this.chosen_emp_id = 0;
            if (this.employeeSearch.name != "") {
                this.employeeSearch.name = ""
            }
            document.getElementById('manager_dropdown').style.display = "block";
            document.getElementById('manager_dropdown').style.display = "block";
            this.getManagers();
        },

        chooseeEmployee(text, value) {
            this.employeeSearch.name = text;
            this.fdata.name = text;
            this.fdata.designation = value;
            document.getElementById('dropdown_div').style.zIndex = "-1";
            document.getElementById('manager_dropdown').style.display = "none";
        },


        getSignatories: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;




            axios.get(this.$api_url + '/signatory', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.signatories = response.data;
                // alpha fix- added this
                  this.people = response.data.length; // added

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editSignatory: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            //this.showoverlay = true;
            axios.get(this.$api_url + '/signatory/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                if (response.data.signature != "") {
                    this.logoUrl = this.$api_url + '/images/company/signature/' + response.data.signature;
                    currentObj.signatory_upload_type = 1;
                }
                else
                    currentObj.signatory_upload_type = 2;

                this.$validator.reset();

                this.$bvModal.show('bv-modal-signatory');
                // alpha fix- added this
                this. Signatory_modal= "Edit Signatory";

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

        },
        deleteSignatory(id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this signatory.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {

                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', id);

                        axios.post(this.$api_url + '/signatory/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.signatories = response.data.signatories;

                            }
                            else {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }

                            this.resetPagination();
                            this.showoverlay_list = false;
                            this.showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.showoverlay_list = false;
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '', designation: '' };
            this.signatory_type = 1;
            this.signatory_upload_type = 1,
                this.logoUrl = '';



            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-signatory');
            // alpha fix- added this
            this.Signatory_modal= "Add Signatory";
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                //this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                if (parseInt(currentObj.signatory_upload_type) == 1) {
                    if (this.logoUploaded)
                        formData.append('signature_image', this.logoUrl);
                } else if (parseInt(currentObj.signatory_upload_type) != 2) {
                    const { isEmpty, data } = currentObj.$refs.signaturePad.saveSignature();
                    if (!isEmpty)
                        formData.append('signature_pad', data);
                }

                formData.append('signatory_upload_type', currentObj.signatory_upload_type);



                //currentObj.saveSignaturePad();


                //console.log(data);



                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/signatory/save', formData, config)
                    .then(function (response) {
                        //console.log(response.data);
                        this.signatories = response.data;

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.showoverlay_list = false;
                        this.showoverlay = false;
                        this.resetForm();
                        //this.movenext = true;

                        this.$bvModal.hide('bv-modal-signatory');

                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay_list = false;
                        this.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

    },
    created: function () {
        this.getManagers();
        this.getSignatories();
        //this.initSignaturePad();

        Fire.$on('reloadUsers', () => { this.getSignatories() });
    },
    computed:
    {

        filteredData() {
            let filtered_list = this.signatories;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });
            }
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },

        filteredItems() {
            if (this.employeeSearch.name.trim().length === 0) {
                return this.manager;
            }
            return this.manager.filter(item => item.text.toLowerCase().indexOf(this.employeeSearch.name.toLowerCase()) > -1)
        }

    }
}

</script>
